<template>
    <v-app>
        <v-snackbar v-model="snack.show" :color="snack.color" top>
            {{ snack.text }}
        </v-snackbar>
        <v-content class="pt-0">
            <Navbar />
            <router-view @snackbar="shoeMsg" />
        </v-content>
        <Footer />
    </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default {
    name: 'App',
    metaInfo: {
        title: 'Ciafarma',
        htmlAttrs: {
            lang: 'es'
        },
        meta: [
            {
                property: 'og:title',
                content: 'Ciafarma'
            },
            { property: 'og:type', content: 'Website' },
            { property: 'og:site_name', content: 'Ciafarma' },
            { property: 'og:url', content: 'ciafarma.com.ar' },
            {
                property: 'og:description',
                content: 'Droguería Ciafarma'
            },
            { property: 'locale', content: 'es_ES' }
        ]
    },
    components: {
        Footer,
        Navbar
    },

    data: () => ({
        snack: { text: '', show: false, color: '' }
    }),

    methods: {
        ...mapActions('products', ['getCartFromStorage']),
        shoeMsg({ text, color }) {
            this.snack.text = text;
            this.snack.show = true;
            this.snack.color = color;
        }
    },
    mounted() {
        this.getCartFromStorage();
    }
};
</script>
